// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rz-2";
export var chatLink = "_rz-0";
export var chatText = "_rz-1";